var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Form from './Form';
import Brand from './Brand';
import Page from '@Components/Page';
import Loader from '@Components/Loader';
import { useAuth } from '../../contexts/AuthContext';
export var Login = function () {
    var loading = useAuth().loading;
    return (_jsxs(Page, { children: [loading && _jsx(Loader, {}), _jsx(CssBaseline, { enableColorScheme: true }), _jsx(Stack, __assign({ direction: "column", component: "main", sx: [
                    {
                        justifyContent: 'space-between',
                        height: { xs: 'auto', md: '100%' },
                    }
                ] }, { children: _jsxs(Stack, __assign({ direction: { xs: 'column-reverse', md: 'row' }, sx: {
                        justifyContent: 'center',
                        p: { xs: 2, sm: 4 },
                        m: 'auto',
                    } }, { children: [_jsx(Brand, {}), _jsx(Form, {})] })) }))] }));
};
